<div id="js-sidebar" class="card-box" style="overflow-y:scroll;">
	{{#each devices}}
	<div  id="{{deviceID}}" class="js-device-values">
		<h5 class="heading">Device: {{deviceID}}</h5>
		{{#each deviceValues}}
		<div class="form-group row">
			<div class="col-sm-4">
				<label id="label-{{@../index}}{{@index}}" class="control-label clickable"> {{r}} </label>
			</div>
			<div class="col-sm-8">
				<input
					id="nr-{{../deviceID}}-{{r}}"
					class="reg-input form-control input-sm"
					name="nr"
					type="number"
					value={{value}}
					min="0"
					max="{{max}}"
					oninput="validity.valid||(value=&#39;&#39;);">
			</div>
		</div>
		{{/each}}
	</div>
	{{/each}}
</div>
